module.exports = __webpack_public_path__ + "img/Skoda_Wordmark_RGB_Electric_Green.bfdfd538.png";